import { FunctionComponent, ReactElement, useCallback } from "react";

import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Icon,
    styled,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";

import { useDeleteLinkView } from "../../../sdk/hooks";
import { ILinkView } from "../../../sdk/types";
import { ILinkViewChangeEvent } from "../../../sdk/utils";

const Root = styled(Dialog)``;

const Content = styled(DialogContent)`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(3)};

    max-width: 350px;
`;

const Title = styled(DialogTitle)`
    font-family: Poppins;
`;

const ActionContainer = styled(DialogActions)`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    gap: ${({ theme }) => theme.spacing(1)};
`;

export interface IDeleteFilterDialogProps {
    id: string;
    label: string;
    view: ILinkView;
    open: boolean;
    onClose: () => void;
    onDeleteEvent: (event: ILinkViewChangeEvent) => void;
}

export const DeleteLinkViewDialog: FunctionComponent<
    IDeleteFilterDialogProps
> = (props: IDeleteFilterDialogProps): ReactElement => {
    const { id, view, label, open, onClose, onDeleteEvent } = props;

    const deleteLinkViewMutation = useDeleteLinkView(["link-views"], {
        onSuccess: () => {
            onDeleteEvent({
                id: id,
                value: view,
                event: "delete",
            });
            onClose();
        },
    });

    const handleSubmitEvent = useCallback(() => {
        deleteLinkViewMutation.mutate({
            id,
        });
    }, [id, deleteLinkViewMutation]);

    return (
        <Root open={open} onClose={onClose}>
            <Title>{label}</Title>
            <Content>
                <Alert
                    variant="outlined"
                    color="warning"
                    icon={<Icon>warning</Icon>}
                >
                    Do you want to delete {view.label} filter?
                </Alert>
            </Content>
            <ActionContainer>
                <Button onClick={onClose} size="small" variant="contained">
                    Cancel
                </Button>
                <LoadingButton
                    type="submit"
                    size="small"
                    variant="contained"
                    loading={deleteLinkViewMutation.isLoading}
                    onClick={handleSubmitEvent}
                >
                    Delete
                </LoadingButton>
            </ActionContainer>
        </Root>
    );
};
